import { standardCode, landingPagesCode } from './verticalSectionMarkerCode';
import { standardLayout, landingLayout } from './verticalSectionMarkerLayouts';

import styles from './verticalSectionMarkerSet.css';

const verticalSectionMarkerSet = [
  {
    component: standardLayout,
    codeTemplate: standardCode,
    previewClass: styles.previewVsm,
    optionsGroup: [
      {
        label: 'Standard',
        options: [
          {label: 'Default', type: 'radio', options: {}},
        ]
      },
      {
        label: 'Count:',
        options: [
          {label: 'sizes', type: 'dropdown', selectList: [
            {label: '8 Options', value: '8', options: {totalItems: 8 }},
            {label: '7 Options', value: '7', options: {totalItems: 7 }},
            {label: '6 Options', value: '6', options: {totalItems: 6 }},
            {label: '5 Options', value: '5', options: {totalItems: 5 }},
            {label: '4 Options', value: '4', options: {totalItems: 4 }},
            {label: '3 Options', value: '3', options: {totalItems: 3 }},
            {label: '2 Options', value: '2', options: {totalItems: 2 }},
            ],
          }
        ]
      }
    ]
  },
  {
    component: landingLayout,
    codeTemplate: landingPagesCode,
    previewClass: styles.previewVsm,
    optionsGroup: [
      {
        label: 'Standard',
        options: [
          {label: 'Default', type: 'radio', options: {}},
        ]
      },
      {
        label: 'Count:',
        options: [
          {label: 'sizes', type: 'dropdown', selectList: [
            {label: '8 Options', value: '8', options: {totalItems: 8, __key: 8 }},
            {label: '7 Options', value: '7', options: {totalItems: 7, __key: 7 }},
            {label: '6 Options', value: '6', options: {totalItems: 6, __key: 6 }},
            {label: '5 Options', value: '5', options: {totalItems: 5, __key: 5 }},
            {label: '4 Options', value: '4', options: {totalItems: 4, __key: 4 }},
            {label: '3 Options', value: '3', options: {totalItems: 3, __key: 3 }},
            {label: '2 Options', value: '2', options: {totalItems: 2, __key: 2 }},
            ],
          }
        ]
      }
    ]
  }
];

export default verticalSectionMarkerSet;


// WEBPACK FOOTER //
// ./src/containers/components/VerticalSectionMarker/constants/verticalSectionMarkerSet.js